import React from 'react';
import { trackEvent } from 'analytics';

function OutboundLink({ to, eventLabel, target, rel, children, ...rest }) {
  const finalRel =
    target === '_blank'
      ? [rel, 'noopener', 'noreferrer'].filter(Boolean).join(' ')
      : rel;
  function onClick() {
    const label = eventLabel || to;
    trackEvent('Outbound Link', 'click', { label, destination: to });
  }
  return (
    <a href={to} target={target} rel={finalRel} onClick={onClick} {...rest}>
      {children}
    </a>
  );
}

export default OutboundLink;
